







import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class MultiqContentIdChip extends Vue {
  @Prop({ required: true }) multiqContentId!: string;
  @Prop({ default: false }) showClosingIcon!: boolean;

  emitCloseClicked() {
    this.$emit('closeClicked');
  }
}
